export const addQueryParam = (
  searchQuery: URLSearchParams,
  key: string,
  value?: string | number | null,
) => {
  if (value !== null && value !== undefined && value !== '') {
    searchQuery.append(key, value.toString())
  }
}
